// extracted by mini-css-extract-plugin
export default {"box":"managers_box__myZfG"};